import { AuthActionResponse } from "./AuthActionResponse";
import { XMLParser } from "fast-xml-parser";

export class AuthActionResponseContainer {
    version: number;
    signature: string;
    response: AuthActionResponse;
    static parserOptions = {
        attributeNamePrefix: "",
        ignoreAttributes: false,
        attributesGroupName: "attrs",
        parseTagValue: false,
        parseAttributeValue: false,
    };
    static parser: XMLParser = new XMLParser(AuthActionResponseContainer.parserOptions);

    constructor(version: number, signature: string, response: AuthActionResponse) {
        this.version = version;
        this.signature = signature;
        this.response = response;
    }

    /** Parsa il file .aares e ritorna un AuthActionResponseContainer o null. Gestire eventuali eccezioni */
    public static async parseFromFile(file: File): Promise<AuthActionResponseContainer> {
        if (file) {
            let reader = new FileReader();

            let result: AuthActionResponseContainer = await new Promise((resolve) => {
                reader.onload = () => {
                    let xmlData = reader.result;
                    let jsonObj = AuthActionResponseContainer.parser.parse(xmlData as string);
                    console.debug("jsonObj from .aares file: ", jsonObj);
                    let container = jsonObj.AuthorizedActionResponseContainer;

                    if (container && container.attrs && container.attrs.v != null) {
                        // switch on version
                        switch (+container.attrs.v) {
                            case 1:
                                result = AuthActionResponseContainer.parseFromFile_v1(container);
                                resolve(result);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                };

                reader.readAsText(file);
            });

            return result;
        } else return null;
    }

    private static parseFromFile_v1(container: any): AuthActionResponseContainer {
        let sign = container.Signature != null ? container.Signature : null;
        let response: AuthActionResponse = AuthActionResponse.deserialize(AuthActionResponseContainer.parser.parse(atob(container.Content)));
        console.debug("Container parseFromFile_v1 | Parsed response: ", response);
        let parsedContainer = new AuthActionResponseContainer(1, sign, response);
        console.debug("parsedContainer: ", parsedContainer);

        return parsedContainer;
    }
}
